export const PAPER_CARD_CLASS =
    'w-full max-w-[700px] min-w-0 overflow-hidden rounded-[14px] border ' +
    'border-[#DBE3E3] bg-white text-[#002429] antialiased ' +
    'shadow-[0_1px_2px_rgba(0,36,41,0.04),0_4px_14px_rgba(0,36,41,0.05)]';
export const PAPER_HEADER_CLASS = 'flex items-center gap-3 px-4 py-3.5';
export const PAPER_TITLE_CLASS =
    'text-base font-semibold leading-5 text-[#002429]';
export const PAPER_SUBTITLE_CLASS = 'text-xs leading-4 text-[#617578]';
export const PAPER_SECTION_LABEL_CLASS =
    'text-[11px] font-semibold tracking-[0.04em] text-[#617578] uppercase';
export const PAPER_FOOTER_CLASS =
    'flex flex-wrap items-center gap-2 border-t border-[#E9F0F0] ' +
    'bg-[#F7FAFA] px-4 py-3';
export const PAPER_OUTLINE_BUTTON_XS_CLASS =
    'inline-flex h-[26px] cursor-pointer items-center justify-center ' +
    'rounded-full border border-[#DBE3E3] bg-white px-[11px] text-xs ' +
    'font-medium whitespace-nowrap text-[#244045] ' +
    'transition-colors hover:bg-[#F0F5F5] disabled:pointer-events-none ' +
    'disabled:opacity-50';
export const PAPER_TAG_CLASS =
    'inline-flex items-center rounded-md bg-[#E3F7FC] px-2 py-0.5 ' +
    'text-[11px] font-medium whitespace-nowrap text-[#0054B5]';
export const PAPER_STATUS_CLASS = {
    positive: 'border-transparent bg-[#E9FCF0] text-[#05614F]',
    info: 'border-transparent bg-[#E3F7FC] text-[#0054B5]',
    warning: 'border-transparent bg-[#FFF2DB] text-[#8C3B00]',
    negative: 'border-transparent bg-[#FFF0F2] text-[#A8002E]',
    neutral: 'border-transparent bg-[#F0F5F5] text-[#42595E]',
} as const;

export function V3PresentationLoadingOrEmpty({
    isLoading,
    noun,
}: {
    readonly isLoading: boolean;
    readonly noun: string;
}) {
    return (
        <p className="border-t border-[#E9F0F0] px-4 py-6 text-center text-xs text-[#617578]">
            {isLoading ? `Loading ${noun}…` : `No ${noun} found`}
        </p>
    );
}

export function V3PresentationFooter({
    visibleCount,
    totalCount,
    hasMoreRows,
    isLoadingMoreRows,
    loadError,
    onShowAll,
}: {
    readonly visibleCount: number;
    readonly totalCount: number;
    readonly hasMoreRows: boolean;
    readonly isLoadingMoreRows: boolean;
    readonly loadError: boolean;
    readonly onShowAll: () => void;
}) {
    return (
        <div className={PAPER_FOOTER_CLASS}>
            <p className="text-xs text-[#617578]">
                {loadError
                    ? 'The saved result could not be loaded.'
                    : `${visibleCount} of ${totalCount}`}
            </p>
            {hasMoreRows ? (
                <button
                    type="button"
                    className={PAPER_OUTLINE_BUTTON_XS_CLASS}
                    disabled={isLoadingMoreRows}
                    onClick={onShowAll}
                >
                    {isLoadingMoreRows ? 'Loading…' : `Show all ${totalCount}`}
                </button>
            ) : null}
        </div>
    );
}
